import { css } from '@compiled/react';
import { createPortal } from 'react-dom';
import Loader from '../common/Loader';

interface LoaderWithPortalProps {
  htmlElement: HTMLElement | null;
}

export default function LoaderWithPortal({ htmlElement }: LoaderWithPortalProps) {
  if (!htmlElement) {
    return null;
  }
  return createPortal(
    <div css={portalStyles}>
      <Loader/>
    </div>, 
    htmlElement
  );
}

const portalStyles = css({
  position: "absolute",
  zIndex: 999,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
});
